import { render, staticRenderFns } from "./BankDirect.vue?vue&type=template&id=be4de71e"
import script from "./BankDirect.vue?vue&type=script&lang=js"
export * from "./BankDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports